import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { switchMap, filter } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import type { Observable } from 'rxjs';

import { SecuredResourceResolverService } from './secured-resource-resolver.service';

@UntilDestroy()
@Component({
  selector: 'miq-secured-resource',
  template: `
    <img *ngIf="src$ | async as src; else failureImage" [src]="src" />
    <ng-template #failureImage>
      <img src="https://via.placeholder.com/{{ width || '1' }}" alt="placeholder" [width]="width" />
    </ng-template>
  `,
  standalone: false,
})
export class SecuredResourceComponent implements OnChanges, OnDestroy {
  @Input() path: string;
  @Input() width: number;
  @Input() options = { responseType: 'blob' };

  private path$: BehaviorSubject<string>;
  public src$: Observable<any>;

  constructor(private securedResourceResolver: SecuredResourceResolverService) {
    this.path$ = new BehaviorSubject(this.path);
    this.src$ = this.path$.pipe(
      untilDestroyed(this),
      filter(url => !!url),
      switchMap(url => this.securedResourceResolver.loadSanitizedImage(url, this.options))
    );
  }

  ngOnChanges() {
    this.path$.next(this.path);
  }

  ngOnDestroy() {
    /** Required by untilDestroy */
  }
}
